<template>
    <div class="animated fadeIn">
        <LoadingWidget
            v-if="initStatus != 1"
            :status="initStatus"
            @init="init"
        />
        <b-card v-else>
            <h5 class="mb-0">
                <i class="fa fa-fw fa-folder-open mr-2" />Divisi Barang
            </h5>
            <hr />
            <b-table
                bordered
                hover
                show-empty
                :busy="isBusy"
                :items="items"
                :fields="fields"
                responsive
                class="mb-3"
            >
                <template v-slot:empty> Tidak ada data admin. </template>
                <template v-slot:cell(name)="row">
                    {{ row.item.name }}
                </template>
                <template v-slot:cell(description)="row">
                    {{ row.item.description }}
                </template>
                <template v-slot:cell(image_path)="row">
                    <b-badge
                        variant="success"
                        v-if="!$helper.isBlank(row.item.image_path)"
                        >Sudah Upload</b-badge
                    >
                    <b-badge variant="danger" v-else>Belum Upload</b-badge>
                </template>
                <template v-slot:cell(action)="row">
                    <b-button
                        size="sm"
                        variant="warning"
                        v-b-tooltip.hover.top
                        :disabled="isBusy || isSubmitting"
                        title="Edit"
                        @click="prepareEdit(row.item)"
                    >
                        <i class="fa fa-fw fa-pencil" />
                    </b-button>
                </template>
            </b-table>
            <!-- <PageSizer :totalRows="totalRows" :page="currentPage" :options="options" @limit-change="onLimitChange" @page-change="onPageChange" /> -->
        </b-card>
        <b-modal
            id="m-edit"
            :title="'Ubah Divisi ' + edit.name"
            no-close-on-backdrop
            no-close-on-esc
            hide-footer
        >
            <b-img-lazy
                class="preview-image mb-3"
                :src="edit.image_path"
            ></b-img-lazy>
            <b-button
                variant="primary"
                class="mb-3"
                :disabled="isSubmitting || isBusy"
                @click="$refs.fileupload.click()"
            >
                Ubah Gambar
            </b-button>
            <!-- <b-form-group
                label="Deskripsi"
                :state="editDescState"
                invalid-feedback="Deskripsi minimal 4 karakter."
            >
                <b-form-textarea
                    v-model="edit.description"
                    :state="editDescState"
                    class="hide-scrollbar"
                    rows="3"
                    max-rows="5"
                    maxlength="1000"
                />
            </b-form-group> -->
            <div class="mt-4 text-right">
                <b-button
                    variant="primary"
                    :disabled="!editDescState || isBusy || isSubmitting"
                    @click="confirmEdit"
                >
                    {{ isSubmitting ? "Menyimpan..." : "Simpan Perubahan" }}
                </b-button>
            </div>
        </b-modal>
        <input
            style="opacity: 0; filter: alpha(opacity=0)"
            ref="fileupload"
            type="file"
            @change="onFileChange"
            accept="image/png, image/jpeg"
        />
    </div>
</template>

<script>
export default {
    data() {
        return {
            initStatus: 0,
            isBusy: true,
            isSubmitting: false,

            edit: {
                id: "",
                name: "",
                description: "",
                image_path: "",
                image: null,
            },

            options: [
                { value: 10, text: "10" },
                { value: 20, text: "20" },
                { value: 30, text: "30" },
                { value: 40, text: "40" },
                { value: 50, text: "50" },
            ],

            fields: [
                // { key: "name", label: "Nama Admin", sortable: true },
                // { key: "email", label: "Email", sortable: true },
                { key: "name", label: "Nama Divisi", sortable: true },
                // { key: "description", label: "Deskripsi", sortable: true },
                { key: "image_path", label: "Gambar", sortable: false },
                { key: "action", label: "Aksi", sortable: false },
            ],

            items: [],

            currentPage: 1,
            perPage: 10,
            totalRows: 0,
            sortBy: "name",
            sortDesc: false,
        };
    },

    methods: {
        init() {
            this.initStatus = 0;
            let getItems = this.getItems();

            Promise.all([getItems])
                .then(() => {
                    this.initStatus = 1;
                })
                .catch((_) => {
                    this.initStatus = -1;
                });
        },

        prepareEdit(item) {
            this.edit.id = item.id;
            this.edit.name = item.name;
            this.edit.description = item.description;
            this.edit.image_path = this.$BASE_FILE_PATH + item.image_path;
            this.edit.image = null;
            this.$refs.fileupload.value = null;
            this.$bvModal.show("m-edit");
        },

        confirmEdit() {
            let data = new FormData();

            data.append("description", this.edit.description);

            if (!this.$helper.isBlank(this.edit.image)) {
                data.append("file", this.edit.image);
            }

            this.isSubmitting = true;

            this.$axios
                .post("admin/updateDivision/" + this.edit.id, data)
                .then((_) => {
                    this.$helper.toastSuccess(
                        this,
                        "Data divisi berhasil diubah!"
                    );
                    this.$bvModal.hide("m-edit");
                    this.getItems(this.currentPage);
                })
                .catch((error) => this.$helper.parseError(this, error))
                .finally(() => (this.isSubmitting = false));
        },

        getItems(page = 1) {
            this.isBusy = true;
            this.items = [];

            // if(isNaN(page)) {
            //     this.currentPage = 1
            // }
            // else {
            //     this.currentPage = page
            // }

            // // URL builder
            // let param = this.$helper.getBasePagedQuery(this.currentPage, this.perPage)

            // if(!this.$helper.isBlank(this.filter.name)) {
            //     param += "&name=" + this.filter.name
            // }

            // if(!this.$helper.isBlank(this.sortBy)) {
            //     param += "&sortBy=" + this.sortBy
            //     param += "&sortDesc=" + this.sortDesc
            // }

            return this.$axios
                .get("master/divisions")
                .then((res) => {
                    this.items = res.data.data;
                    // this.totalRows = res.data.data.total
                    // sessionStorage.setItem("listAdminFilter", JSON.stringify(this.filter))
                })
                .catch((error) => {
                    this.$helper.parseError(this, error);
                })
                .finally(() => {
                    this.isBusy = false;
                });
        },

        // onLimitChange(newPerPage) {
        //     this.perPage = newPerPage
        //     this.getItems(this.currentPage)
        // },

        // onPageChange(newPage) {
        //     this.currentPage = newPage
        //     this.getItems(this.currentPage)
        // },

        // onSortChanged(ctx) {
        //     this.sortBy = ctx.sortBy
        //     this.sortDesc = ctx.sortDesc
        //     this.getItems()
        // },

        onFileChange(e) {
            var files = e.target.files || e.dataTransfer.files;
            if (!files.length) return;
            else if (files[0].size > this.$uploadLimit) {
                this.$helper.toastError(
                    this,
                    "Ukuran gambar tidak boleh melebihi 5MB!"
                );
                return;
            }
            this.edit.image = files[0];
            this.edit.image_path = URL.createObjectURL(files[0]);
        },
    },

    computed: {
        editDescState() {
            if (this.edit.description.length <= 0) return null;
            return this.edit.description.length >= 4;
        },
    },

    created() {
        // if(!this.$helper.isBlank(sessionStorage.getItem("listAdminFilter"))){
        //     this.filter = JSON.parse(sessionStorage.getItem("listAdminFilter"))
        // }
        this.init();
    },
};
</script>

<style scoped>
.preview-image {
    object-fit: cover;
    object-position: center;
    width: 100%;
    aspect-ratio: 1 / 1;
    max-height: 450px;
}
.hide-scrollbar {
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* Internet Explorer 10+ */
}
.hide-scrollbar::-webkit-scrollbar {
    /* WebKit */
    display: none;
    width: 0;
    height: 0;
}
</style>
